require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ../~/angular-cookies/index.js
// module id = 87
// module chunks = 1